import { BaseInvitePeopleAnalytics } from '../BaseInvitePeopleAnalytics';
import { AnalyticsAction, AnalyticsActionSubject, type AnalyticsAttributes } from '../../types';

export class InstrumentedButtonAnalytics extends BaseInvitePeopleAnalytics {
	buttonClicked(actionSubjectId: string, attributes: AnalyticsAttributes) {
		this.fireUI({
			action: AnalyticsAction.CLICKED,
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId,
			attributes,
		});
	}
}
